import { CALL_API } from "../../api";
import * as ActionTypes from "./channel.actionTypes";
import schema from "../../api/schema";

const readChannels = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CHANNELS_REQUEST,
      ActionTypes.READ_CHANNELS_SUCCESS,
      ActionTypes.READ_CHANNELS_FAILURE
    ],
    endpoint: "api/channel/",
    schema: schema.channelsSchema,
    authorization: true
  }
});

export const getChannels = () => (dispatch, getState) => {
  return dispatch(readChannels());
};

const readChannel = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CHANNEL_REQUEST,
      ActionTypes.READ_CHANNEL_SUCCESS,
      ActionTypes.READ_CHANNEL_FAILURE
    ],
    endpoint: `api/channel/${id}`,
    schema: schema.channelSchema,
    authorization: true
  },
  payload: {
    id
  }
});

export const getChannel = id => (dispatch, getState) => {
  return dispatch(readChannel(id));
};

const doCreateChannel = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_CHANNEL_REQUEST,
      ActionTypes.CREATE_CHANNEL_SUCCESS,
      ActionTypes.CREATE_CHANNEL_FAILURE
    ],
    endpoint: "api/channel/",
    schema: schema.channelSchema,
    authorization: true,
    requestInit: {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(data)
    }
  }
});

export const createChannel = data => (dispatch, getState) => {
  return dispatch(doCreateChannel(data));
};

const doUpdateChannel = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_CHANNEL_REQUEST,
      ActionTypes.UPDATE_CHANNEL_SUCCESS,
      ActionTypes.UPDATE_CHANNEL_FAILURE
    ],
    endpoint: `api/channel/${data._id}`,
    schema: schema.channelSchema,
    authorization: true,
    requestInit: {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(data)
    }
  },
  payload: {
    id: data._id
  }
});

export const updateChannel = data => (dispatch, getState) => {
  return dispatch(doUpdateChannel(data));
};

const doDeleteChannel = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_CHANNEL_REQUEST,
      ActionTypes.DELETE_CHANNEL_SUCCESS,
      ActionTypes.DELETE_CHANNEL_FAILURE
    ],
    endpoint: `api/channel/${id}`,
    schema: schema.channelSchema,
    authorization: true,
    requestInit: {
      method: "DELETE"
    }
  },
  payload: {
    id
  }
});

export const deleteChannel = id => (dispatch, getState) => {
  return dispatch(doDeleteChannel(id));
};

const readTopSellers = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.TOP_SELLERS_REQUEST,
      ActionTypes.TOP_SELLERS_SUCCESS,
      ActionTypes.TOP_SELLERS_FAILURE
    ],
    endpoint: `api/channel/top/sellers`,
    schema: schema.topSellersSchema,
    authorization: true
  }
});

export const getTopSellers = () => (dispatch, getState) => {
  return dispatch(readTopSellers());
};



// WEBPACK FOOTER //
// ./src/modules/channel/channel.actions.js